import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { useNavigate } from 'react-router-dom';
import { stopMasquerade } from '../../app/store/masqueradeSlice';
import type { RootState } from '../../app/store';
import { fetchUserDataByToken } from '../../app/store/userSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';

export default function MasqueradeBanner() {
  const { userId, userDisplay } = useAppSelector((state: RootState) => state.masquerade);
  const dispatch = useAppDispatch();
  const nav = useNavigate();

  if (!userId) return null;

  const existMasqueradeSession = async () => {
    dispatch(stopMasquerade());
    await dispatch(fetchUserDataByToken());
    nav('/admin/users', { replace: true });
  };

  return (
    <Alert
      severity="warning"
      icon={<SupervisorAccountIcon />}
      sx={{
        borderRadius: 0,
        position: 'sticky',
        top: 0,
        flexShrink: 0,
        zIndex: (theme) => theme.zIndex.appBar + 1,
        '& .MuiAlert-message': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        },
        paddingX: 2,
      }}
      action={
        <Button
          color="inherit"
          size="small"
          variant="outlined"
          onClick={() => existMasqueradeSession()}
          sx={{ whiteSpace: 'nowrap' }}
        >
          Exit Masquerade
        </Button>
      }
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2">
          You are currently acting as <strong>{userDisplay}</strong>
        </Typography>
      </Box>
    </Alert>
  );
}
